// @flow

import { i18n } from 'shared/utils';

export default () => [
  {
    label: i18n.t('Invoice # · Low to High'),
    value: { field: 'INVOICE_NUMBER', direction: 'ASC' },
  },
  {
    label: i18n.t('Invoice # · High to Low'),
    value: { field: 'INVOICE_NUMBER', direction: 'DESC' },
  },
  {
    label: i18n.t('Customer · A to Z'),
    value: { field: 'CUSTOMER', direction: 'ASC' },
  },
  {
    label: i18n.t('Customer · Z to A'),
    value: { field: 'CUSTOMER', direction: 'DESC' },
  },
  {
    label: i18n.t('Order # · Low to High'),
    value: { field: 'ORDER_NUMBER', direction: 'ASC' },
  },
  {
    label: i18n.t('Order # · High to Low'),
    value: { field: 'ORDER_NUMBER', direction: 'DESC' },
  },
  {
    label: i18n.t('Status · A to Z'),
    value: { field: 'STATUS', direction: 'ASC' },
  },
  {
    label: i18n.t('Status · Z to A'),
    value: { field: 'STATUS', direction: 'DESC' },
  },
  {
    label: i18n.t('Total Amount · Low to High'),
    value: { field: 'TOTAL_AMOUNT', direction: 'ASC' },
  },
  {
    label: i18n.t('Total Amount · High to Low'),
    value: { field: 'TOTAL_AMOUNT', direction: 'DESC' },
  },
  {
    label: i18n.t('Amount Due · Low to High'),
    value: { field: 'AMOUNT_DUE', direction: 'ASC' },
  },
  {
    label: i18n.t('Amount Due · High to Low'),
    value: { field: 'AMOUNT_DUE', direction: 'DESC' },
  },
  {
    label: i18n.t('Issue Date - Oldest'),
    value: { field: 'ISSUE_DATE', direction: 'ASC' },
  },
  {
    label: i18n.t('Issue Date - Most Recent'),
    value: { field: 'ISSUE_DATE', direction: 'DESC' },
  },
  {
    label: i18n.t('Due Date - Oldest'),
    value: { field: 'DUE_DATE', direction: 'ASC' },
  },
  {
    label: i18n.t('Due Date - Most Recent'),
    value: { field: 'DUE_DATE', direction: 'DESC' },
  },
  {
    label: i18n.t('Last Updated - Oldest'),
    value: { field: 'UPDATED_AT', direction: 'ASC' },
  },
  {
    label: i18n.t('Last Updated - Most Recent'),
    value: { field: 'UPDATED_AT', direction: 'DESC' },
  },
  {
    label: i18n.t('Date Created - Oldest'),
    value: { field: 'CREATED_AT', direction: 'ASC' },
  },
  {
    label: i18n.t('Date Created - Most Recent'),
    value: { field: 'CREATED_AT', direction: 'DESC' },
  },
];
